import { AbstractSecurityStorage } from "@delfi-gui/angular-auth-oidc-client";

export class CustomLocalStore implements AbstractSecurityStorage {
    private keys: Set<string> = new Set<string>();
    public read(key: string): any {
      this.keys.add(key);
      return localStorage.getItem(key)
    }
  
    public write(key: string, value: any) {
      this.keys.add(key);
      localStorage.setItem(key, value)
    }
  
    public remove(key: string) {
      localStorage.removeItem(key)
    }
  
    public clear() {
      // cleaning up only keys that this storage class touched
      for (const k in this.keys) {
        localStorage.remove(k);
      }
    }
  }